import { TFunction } from "i18next";
import { Colleague } from "../../../features/Connections/types/Colleague.type";
import { RemoteCompany } from "../../../hooks/Remote/Companies/useRemoteFetchCompanies";
import { CompanyUnits } from "../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";
import { IPermission } from "../Domain/Types/FloorPlan/Permission.type";
import { capitalize } from "../Components/Toolbars/InfoSidebar/PermissionSelect/PermissionSelect.functions";

export const generatePermRows = (
  entryWithPerms: IPermission[],
  remoteUnits: {
    remoteCompanies: RemoteCompany[] | undefined;
    remoteCompanyUnits: CompanyUnits[] | undefined;
    remoteUsers: Colleague[] | undefined;
  },
  t: TFunction
) => {
  const { remoteCompanies, remoteCompanyUnits, remoteUsers } = remoteUnits;

  const remoteCompaniesData = remoteCompanies ?? [];
  const remoteCompanyUnitsData = remoteCompanyUnits ?? [];
  const remoteUsersData = remoteUsers ?? [];

  const companyRows = entryWithPerms.flatMap(permission =>
    permission.affectedCompanies.map(company => ({
      permissionType: t("Company"),
      permittedIs: remoteCompaniesData.find(data => data.id.toString() === company.id)?.name,
      spillover: company.enforceUsage ? t("Yes") : t("No"),
      permittedWeekdays: permission.activeWeekdays.map(day => t(capitalize(day))).join(", "),
      leadTime: company.hoursInAdvance
    }))
  );

  const departmentRows = entryWithPerms.flatMap(permission =>
    permission.affectedDepartments.map(department => ({
      permissionType: t("Department"),
      permittedIs: remoteCompanyUnitsData.find(data => data.id === department.id)?.name,
      spillover: department.enforceUsage ? t("Yes") : t("No"),
      permittedWeekdays: permission.activeWeekdays.map(day => t(capitalize(day))).join(", "),
      leadTime: department.hoursInAdvance
    }))
  );

  const userRows = entryWithPerms.flatMap(permission =>
    permission.affectedUsers.map(user => {
      const found = remoteUsersData.find(data => data.userId === user.id);

      return {
        permissionType: t("User"),
        permittedIs: `${found?.firstName} ${found?.surname}`,
        spillover: user.enforceUsage ? t("Yes") : t("No"),
        permittedWeekdays: permission.activeWeekdays.map(day => t(capitalize(day))).join(", "),
        leadTime: user.hoursInAdvance
      };
    })
  );

  return [...companyRows, ...departmentRows, ...userRows];
};
